import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Checkbox, Form, Input, Modal, Radio } from "antd";

const EditDefaultComponent = ({
	selectCategory,
	selectKey,
	defaultList,
	setDefaultList,
	categoryList,
}) => {
	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);

	const [exampleModal, setExampleModal] = useState(false);
	const [example, setExample] = useState("");

	const handleFormData = (e) => {
		let { name, value } = e.target;
		if (name === "category_id") {
			let value = e.target.value
				.replace(/[^a-zA-Z0-9_ ]/g, "")
				.replace(" ", "_");
			setDefaultList({
				...defaultList,
				[name]: value,
			});
		} else if (name === "explanation") {
			if (selectCategory === 0) {
				setDefaultList({
					...defaultList,
					explanation: value,
				});
			} else {
				setDefaultList({
					...defaultList,
					reason: value,
				});
			}
		} else if (name === "is_show") {
			let topSearch = selectKey?.is_top_searched;
			let faq = selectKey?.is_faq;
			if (selectCategory === 0) {
				if (value) {
					setDefaultList({
						...defaultList,
						[name]: value,
					});
				} else {
					if (topSearch) {
						alert("인기검색어에 해당 카테고리가 존재합니다.");
					} else if (faq) {
						alert("자주 묻는 질문 관련 성분에 해당 카테고리가 존재합니다.");
					} else {
						setDefaultList({
							...defaultList,
							[name]: value,
						});
					}
				}
			} else {
				if (value) {
					setDefaultList({
						...defaultList,
						[name]: value,
					});
				} else {
					if (topSearch) {
						alert("인기검색어에 해당 카테고리가 존재합니다.");
					} else {
						setDefaultList({
							...defaultList,
							[name]: value,
						});
					}
				}
			}
		} else {
			setDefaultList({
				...defaultList,
				[name]: value,
			});
		}
	};

	/**
	 * 옵션 가져오기
	 * @type {*[]}
	 */
	const relationOptions = categoryList?.ingredientList
		? categoryList.ingredientList?.map((item) => {
				return {
					id: item.id,
					label: item?.ingredient_name,
					value: item?.ingredient_id,
				};
		  })
		: [];

	/**
	 * 관련 성분 체크
	 * @param e
	 */
	const handleRelation = (value) => {
		let list = [...value];
		let checkList = categoryList?.ingredientList
			.filter((item) => list.includes(item.ingredient_id))
			.map((item) => {
				const findRelationIdx = defaultList?.relation_list?.findIndex(
					(relationItem) => relationItem?.ingredient_id === item.ingredient_id
				);
				const findSelectIngredientIdx = selectKey?.ingredientList?.findIndex(
					(selectIngredientItem) =>
						selectIngredientItem?.ingredient_id === item.ingredient_id
				);
				if (findRelationIdx > -1) {
					const newItem = {
						...item,
						explanation:
							defaultList?.relation_list[findRelationIdx].explanation,
					};
					return newItem;
				} else if (findSelectIngredientIdx > -1) {
					const newItem = {
						...item,
						explanation:
							selectKey?.ingredientList[findSelectIngredientIdx].explanation,
					};
					return newItem;
				} else {
					return item;
				}
			});
		setDefaultList({
			...defaultList,
			relation_list: checkList,
		});
	};

	const handleRelationReason = (e, idx) => {
		let { value } = e.target;
		let list = [...defaultList.relation_list];
		let findItem = list[idx];
		let newFindItem = {
			...findItem,
			explanation: value,
		};
		list[idx] = newFindItem;
		setDefaultList({
			...defaultList,
			relation_list: list,
		});
	};

	return (
		<div className={`body-default-each`}>
			<p className={`body-each-title`}>기본 설정</p>
			<Form className={`form-border`} labelCol={{ span: 5 }}>
				{/* 카테고리 노출 */}
				<Form.Item
					label={`노출/미노출`}
					labelAlign="left"
					colon={false}
					className={`form-border-item`}
					required={true}
				>
					<Radio.Group
						defaultValue={defaultList?.is_show ?? 0}
						value={defaultList?.is_show ?? 0}
						onChange={handleFormData}
						name={`is_show`}
						disabled={
							isLoading ||
							!selectKey ||
							(!!selectKey && !Object.keys(selectKey)?.length)
						}
					>
						<Radio value={1}>노출</Radio>
						<Radio value={0}>미노출</Radio>
					</Radio.Group>
				</Form.Item>

				{/* 중요 태그 */}
				<Form.Item
					label={
						<div className={`label-div`}>
							<p>중요 태그</p>
							<p
								className={`example`}
								onClick={() => {
									setExampleModal(true);
									setExample("main-tag");
								}}
							>
								예시
							</p>
						</div>
					}
					labelAlign="left"
					colon={false}
					className={`form-border-item`}
					required={true}
				>
					<Radio.Group
						defaultValue={defaultList?.main_tag ?? 0}
						value={defaultList?.main_tag ?? 0}
						onChange={handleFormData}
						name={`main_tag`}
						disabled={
							isLoading ||
							!selectKey ||
							(!!selectKey && !Object.keys(selectKey)?.length)
						}
					>
						<Radio value={0}>일반</Radio>
						<Radio value={1}>HOT(1순위)</Radio>
						<Radio value={2}>BEST(2순위)</Radio>
					</Radio.Group>
				</Form.Item>

				{/* 댓글 허용 */}
				{/*reduxChannel?.user_id === 1*/}
				{/*{user?.id !== 7 && selectCategory !== 1 && (*/}
				{/*// {selectCategory !== 1 && (*/}
				{/*    <Form.Item*/}
				{/*        label={`댓글 허용`}*/}
				{/*        labelAlign="left"*/}
				{/*        colon={false}*/}
				{/*        className={`form-border-item`}*/}
				{/*        required={true}*/}
				{/*    >*/}
				{/*        <Radio.Group*/}
				{/*            defaultValue={defaultList?.is_comment_show ?? 0}*/}
				{/*            value={defaultList?.is_comment_show ?? 0}*/}
				{/*            onChange={handleFormData}*/}
				{/*            name={`is_comment_show`}*/}
				{/*            disabled={isLoading}*/}
				{/*        >*/}
				{/*            <Radio value={1}>*/}
				{/*                허용*/}
				{/*            </Radio>*/}
				{/*            <Radio value={0}>*/}
				{/*                미허용*/}
				{/*            </Radio>*/}
				{/*        </Radio.Group>*/}
				{/*    </Form.Item>*/}
				{/*)}*/}

				{/* 카테고리명 */}
				<Form.Item
					label={`카테고리명`}
					labelAlign="left"
					colon={false}
					className={`form-border-item`}
					required={true}
				>
					<Input
						type={`text`}
						className={`category_name`}
						disabled={
							isLoading ||
							!selectKey ||
							(!!selectKey && !Object.keys(selectKey)?.length)
						}
						value={defaultList?.category_name}
						onChange={handleFormData}
						name={`category_name`}
					/>
				</Form.Item>

				{/* 카테고리명 */}
				{selectCategory !== 2 && (
					<Form.Item
						label={`영문명`}
						labelAlign="left"
						colon={false}
						className={`form-border-item`}
						required={true}
					>
						<Input
							type={`text`}
							disabled={
								isLoading ||
								!selectKey ||
								(!!selectKey && !Object.keys(selectKey)?.length)
							}
							value={defaultList?.category_id}
							onChange={handleFormData}
							name={`category_id`}
						/>
						<p className={`explain-text`}>
							중복 데이터를 피하기 위해 해당 성분의 성분명을 영어로
							작성해주세요. (임의로 작성 하셔도 됩니다)
						</p>
					</Form.Item>
				)}

				{/* 연관 고민 */}
				{selectCategory === 0 && user?.id !== 9 && user?.partners_id !== 9 && (
					<Form.Item
						label={`연관 고민`}
						labelAlign="left"
						colon={false}
						className={`form-border-item`}
					>
						<Input
							type={`text`}
							name={`ingredient-name`}
							className={`ingredient-name`}
							disabled={true}
							value={selectKey?.associatedFunctionList?.map(
								(item) => item.function_name
							)}
						/>
					</Form.Item>
				)}

				{/* 성분 설명 */}
				{(selectCategory === 2 ||
					user?.id === 9 ||
					user?.partners_id === 9) && (
					<Form.Item
						label={
							<div className={`label-div`}>
								{user?.id === 9 || user?.partners_id === 9 ? (
									<p>고민 설명</p>
								) : (
									<>
										{selectCategory === 0 ? <p>성분 설명</p> : <p>조합 설명</p>}
									</>
								)}
								<p
									className={`example`}
									onClick={() => {
										setExampleModal(true);
										if (user?.id === 9 || user?.partners_id === 9) {
											setExample("explain");
										} else {
											if (selectCategory === 0) {
												setExample("ingredient-example");
											} else {
												setExample("explain");
											}
										}
									}}
								>
									예시
								</p>
							</div>
						}
						labelAlign="left"
						colon={false}
						className={`form-border-item`}
					>
						<Input.TextArea
							type={`text`}
							placeholder={`카테고리에 대한 설명을 입력해주세요.`}
							value={
								selectCategory === 0
									? defaultList?.explanation
									: defaultList?.reason
							}
							onChange={handleFormData}
							name={`explanation`}
							style={{
								minHeight: "8em",
							}}
							disabled={
								!selectKey || (!!selectKey && !Object.keys(selectKey)?.length)
							}
						/>
					</Form.Item>
				)}

				{/* 관련 성분 */}
				{selectCategory === 1 && (
					<Form.Item
						label={
							<div className={`label-div`}>
								<p>관련 성분 {defaultList?.relation_list?.length ?? 0}개</p>
							</div>
						}
						labelAlign="left"
						colon={false}
						className={`form-border-item`}
					>
						<Checkbox.Group
							options={relationOptions?.length ? relationOptions : []}
							className={`category-relation-checkbox`}
							onChange={handleRelation}
							value={defaultList?.relation_list?.map(
								(item) => item?.ingredient_id
							)}
							disabled={
								isLoading ||
								!selectKey ||
								(!!selectKey && !Object.keys(selectKey)?.length)
							}
						/>
					</Form.Item>
				)}

				{/*성분 추천 이유*/}
				{selectCategory === 1 && (
					<Form.Item
						label={
							<div className={`label-div`}>
								<p>성분 추천 이유</p>
								<p
									className={`example`}
									onClick={() => {
										setExampleModal(true);
										setExample("ingredient-recommend-reason");
									}}
								>
									예시
								</p>
							</div>
						}
						labelAlign="left"
						colon={false}
						className={`form-border-item`}
					>
						{defaultList?.relation_list?.map((ingredient, idx) => (
							<div
								key={`relation_ingredient_${idx}`}
								className={`category-relation-reason-div`}
								style={{ gap: "1em" }}
							>
								<p className={`category-relation-reason-label`}>
									{ingredient?.ingredient_name}
								</p>
								<Input.TextArea
									type={`text`}
									value={ingredient?.explanation}
									onChange={(e) => handleRelationReason(e, idx)}
									name={`explanation`}
									style={{
										minHeight: "2em",
										resize: "none",
									}}
									disabled={
										!selectKey ||
										(!!selectKey && !Object.keys(selectKey)?.length)
									}
								/>
							</div>
						))}
					</Form.Item>
				)}
			</Form>

			<Modal
				title={`${
					example === "main-tag"
						? "중요 태그 예시"
						: example === "ingredient-recommend-reason"
						? "성분 추천 이유 예시"
						: user?.id === 9 || user?.partners_id === 9
						? "고민 설명 예시"
						: selectCategory === 0
						? "성분 설명 예시"
						: "조합 설명 예시"
				}`}
				wrapClassName="sms-send-modal"
				open={exampleModal}
				centered={true}
				onCancel={() => {
					setExampleModal(!exampleModal);
				}}
				width="60%"
				footer={null}
				style={{
					maxWidth: 900,
				}}
			>
				<img
					src={`/assets/images/landing/${example}.jpg`}
					alt={`예시 모달`}
					style={{
						height: "auto",
						width: "100%",
					}}
				/>
			</Modal>
		</div>
	);
};
export default EditDefaultComponent;
